export default __webpack_public_path__ + "static/media/logo.c14bdadd.png";